export default __webpack_public_path__ + "static/media/save.c257c0b4.png";